export enum TrackingClass {
    NEXT_STEP = 'next_step',
    NEXT = 'next',
    PEN_ICON = 'pen_icon',
    BACK_TO_HC = 'back_to_HC',
    CANCEL_CTA = 'cancel_cta',
    LINK_OUT_CTA = 'link_out_cta',
    CHECK24_CANCELLATION_CTA = 'check24_cancellation_cta',
    PRODUCT_SELECT = 'product_select',
    LOGIN = 'login',
}
